export function textTransformFirstLetterUpper(content: string) {
	return content.charAt(0).toUpperCase() + content.slice(1);
}

export function getAcronym(content: string) {
	return content
		.toUpperCase()
		.split(/\s/)
		.reduce(
			(response, word) =>
				(response += word.replace(/[^a-zA-Z0-9]+/g, '').slice(0, 1)),
			'',
		);
}
